const prefix = 'u-';

const getUtilityClassName = (value: string): string => (value ? `${prefix}${value}` : '');

export default getUtilityClassName;
